'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  '& .input > input': {
    cursor: 'pointer'
  },
  '& .input.disabled > input': {
    cursor: 'not-allowed'
  },

  '& .header': {
    backgroundColor: 'rgba(200,0,0,1)',
    color: '#fff',
    cursor: 'pointer',
    padding: '15px'
  },

  '& .year': {
    display: 'inline-block',
    fontSize: '14px'
    // transition: opacity, fontSize var(--animation-duration) var(--animation-curve-default),
  },

  '& .date': {
    display: 'block',
    fontSize: '28px',
    fontWeight: 400,
    // lineHeight: calc(4 * var(--unit)),
    margin: 0,
    textTransform: 'capitalize'
    // transition: opacity var(--animation-duration) var(--animation-curve-default),
  },

  '& .calendarWrapper': {
    padding: '10px'
  },
  '& .calendarActions': {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '5px',
    '& .action': {
      color: 'rgb(200, 0, 0)',
      cursor: 'pointer',
      marginLeft: '5px',
      padding: '5px 10px',
      transition: 'background-color 150ms ease-in-out'
    },
    '& .action:hover': {
      backgroundColor: 'rgba(200, 0, 0, .2)'
    }
  },

  '& .yearsDisplay': {
    '& .date': {
      // opacity: var(--datepicker-inactive-opacity),
    },

    '& .year': {
      // fontSize: var(--fontSize-normal),
    }
  },

  '& .monthsDisplay': {
    '& .year': {
      // opacity: var(--datepicker-inactive-opacity),
    }
  },

  '& .dialog': {
    width: '300px',
    padding: 0,

    '& > [role="body"]': {
      padding: 0
    },

    '& > [role="navigation"] > .button': {
      // color: var(--datepicker-primary-color),

      '&:hover': {
        // background: var(--datepicker-primary-hover-color),
      },

      '&:focus:not(:active)': {
        // background: var(--datepicker-primary-hover-color),
      }
    }
  },

  '& .calendar': {
    background: '#fff',
    fontSize: '14px',
    height: '260px',
    overflow: 'hidden',
    position: 'relative',
    textAlign: 'center',

    '& .prev, & .next': {
      color: 'black',
      cursor: 'pointer',
      fontSize: '12px',
      height: '26px',
      opacity: 0.7,
      position: 'absolute',
      top: 0,

      '& i': {
        fontSize: '16px'
      },

      // zIndex: var(--z-index-high),

      '& > span': {
        verticalAlign: 'top'
      }
    },

    '& .prev': {
      left: 0
    },

    '& .next': {
      right: 0
    }
  },

  '& .title': {
    display: 'inline-block',
    fontWeight: 500,
    lineHeight: '30px'
  },

  '& .years': {
    // fontSize: var(--fontSize-big),
    height: '100%',
    listStyle: 'none',
    margin: 0,
    overflowY: 'auto',
    padding: 0,

    '& > li': {
      cursor: 'pointer',
      lineHeight: 2.4,

      '&.active': {
        color: 'rgb(200, 0, 0)',
        fontWeight: 'bold'
      }
    }
  },

  '& .week': {
    display: 'flex',
    flexWrap: 'wrap',
    // fontSize: var(--calendar-day-fontSize),
    height: '30px',
    lineHeight: '30px',
    opacity: 0.5,

    '& > span': {
      flex: '0 0 calc(100% / 7)'
    }
  },

  '& .days': {
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: 'var(--calendar-day-fontSize)'
  },

  '& .day': {
    flex: '0 0 calc(100% / 7)',

    '& > span': {
      borderRadius: '50%',
      display: 'inline-block',
      height: '30px',
      lineHeight: '30px',
      transition: '100ms background ease-in-out, 100ms color ease-in-out',
      width: '30px'
    },

    '&:hover:not(.active):not(.disabled) > span': {
      background: 'rgba(200,0,0,0.5)',
      color: '#fff'
    },

    '&.active > span': {
      background: 'rgb(200,0,0)',
      color: '#fff'
    },

    '&:hover:not(.disabled) > span': {
      cursor: 'pointer'
    },

    '&.disabled': {
      opacity: 0.5
    }
  },

  '.month': {
    backgroundColor: 'magenta'
  },

  '& .slideRight .slide-enter, & .slideRight .slide-exit': {
    position: 'absolute'
  },

  '& .slideRight .slide-enter-active, & .slideRight .slide-exit-active': {
    transitionDuration: '350ms',
    transitionProperty: 'transform, opacity',
    transitionTimingFunction: 'ease-in-out'
  },

  '& .slideRight .slide-enter': {
    opacity: 0,
    transform: 'translateX(100%)'
  },
  '& .slideRight .slide-enter.slide-enter-active': {
    opacity: 1,
    transform: 'translateX(0)'
  },

  '& .slideRight .slide-exit': {
    opacity: 1,
    transform: 'translateX(0)'

  },
  '&  .slideRight .slide-exit.slide-exit-active': {
    opacity: 0,
    transform: 'translateX(-100%)'
  },

  '& .slideLeft .slide-enter, & .slideLeft .slide-exit': {
    position: 'absolute',
    transitionDuration: '0.35s',
    transitionProperty: 'transform, opacity',
    transitionTimingFunction: 'ease-in-out'
  },

  '& .slideLeft .slide-enter': {
    opacity: 0,
    transform: 'translate3d(-100%, 0, 0)'
  },
  '& .slideLeft .slide-enter.slide-enter-active': {
    opacity: 1,
    transform: 'translate3d(0, 0, 0)'
  },

  '& .slideLeft .slide-exit': {
    opacity: 1,
    transform: 'translate3d(0, 0, 0)'
  },
  '& .slideLeft .slide-exit.slide-exit-active': {
    opacity: 0,
    transform: 'translate3d(100%, 0, 0)'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(props, theme) {
  return (0, _extends3.default)({}, (0, _objectResolvePath2.default)(theme, 'DatePicker.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/DatePicker/DatePicker.style.js
// module id = 477
// module chunks = 0